import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { AppConstants } from 'src/app/app.constants';

@Injectable({
  providedIn: 'root'
})
export class AppealEventsService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getAllAppealEvents(): Observable<any> {
    return this.http.get<any>(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.EMAIL_LITIGATION.APPEAL_EVENTS_DASHBOARD}`
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}
